export const MenuCustom = [

    {
        menutitle: "DashBoard",
        menucontent: "Ready to use Apps",
        Items: [
            { path: `${process.env.PUBLIC_URL}/admin/dashboard/sales`, icon: "charts", title: "Sales", type: "link" },
            { path: `${process.env.PUBLIC_URL}/admin/dashboard/traffic`, icon: "charts", title: "Traffic", type: "link" },
        ],
    },
    {
        menutitle: "Reports",
        menucontent: "Ready to use Apps",
        Items: [
            {
                title: "Reports",
                icon: "file",
                type: "sub",
                badge: "badge badge-light-secondary",
                active: false,
                children: [

                    { path: `${process.env.PUBLIC_URL}/admin/report/daywisereport`, icon: "file", title: "Daywise Report", type: "link" },
                    { path: `${process.env.PUBLIC_URL}/admin/report/mtdreport`, icon: "file", title: "MTD Report", type: "link" },
                    { path: `${process.env.PUBLIC_URL}/admin/report/daywiseconsolidated`, icon: "file", title: "Sales Summary Report", type: "link" },
                    { path: `${process.env.PUBLIC_URL}/admin/report/monthwisesales`, icon: "file", title: "Monthwise Sales Report", type: "link" },
                    { path: `${process.env.PUBLIC_URL}/admin/report/revenuesharereport`, icon: "file", title: "Revenue Share Report", type: "link" },
                    { path: `${process.env.PUBLIC_URL}/admin/report/tradingdensityreport`, icon: "file", title: "Trading Density Report", type: "link" },
                    { path: `${process.env.PUBLIC_URL}/admin/report/dailycomprehensiverevenue`, icon: "file", title: "Daily Comprehensive Revenue Report", type: "link" },
                    { path: `${process.env.PUBLIC_URL}/admin/report/growthanalysisreport`, icon: "file", title: "Growth Analysis Report", type: "link" },
                    { path: `${process.env.PUBLIC_URL}/admin/report/fbsalessummary`, icon: "file", title: "F&B Sales Summary", type: "link" },
                    { path: `${process.env.PUBLIC_URL}/admin/report/deliverypartnerreport`, icon: "file", title: "Sales Report-Delivery Partners", type: "link" },
                    { path: `${process.env.PUBLIC_URL}/admin/report/missingdates`, icon: "file", title: "Missing Dates Report", type: "link" },
                    { path: `${process.env.PUBLIC_URL}/admin/report/additionalsalessummary`, icon: "file", title: "Additional Sales Summary Reports", type: "link" },
                    { path: `${process.env.PUBLIC_URL}/admin/dynamicreports`, icon: "file", title: "Dynamic Reports", type: "link" },
                ],
            },
            {
                title: "More Reports",
                icon: "table",
                type: "sub",
                badge: "badge badge-light-secondary",
                active: false,
                children: [

                    { path: `${process.env.PUBLIC_URL}/admin/report/itemwisereport`, icon: "file", title: "Itemwise Detail Report", type: "link" },
                    ...(localStorage.getItem("auditRequired") === "true"
                        ? [{
                            path: `${process.env.PUBLIC_URL}/admin/report/tenantauditreport`, icon: "file", title: "Audit Detail Report", type: "link"
                        }] : []), { path: `${process.env.PUBLIC_URL}/admin/report/invoicewisesalesreport`, icon: "file", title: "Invoicewise Report", type: "link" },
                    { path: `${process.env.PUBLIC_URL}/admin/report/hourlysalesreport`, icon: "file", title: "Hourly Sales Report", type: "link" },
                    { path: `${process.env.PUBLIC_URL}/admin/report/tenantitemwisesales`, icon: "file", title: "Tenant Itemwise Report", type: "link" },
                    { path: `${process.env.PUBLIC_URL}/admin/report/consolidateddaywisereport`, icon: "file", title: "Consolidated Daywise Report", type: "link" },
                    { path: `${process.env.PUBLIC_URL}/admin/report/timeseriestrendchartreport`, icon: "file", title: "TimeSeries Trend LineChart", type: "link" },
                    { path: `${process.env.PUBLIC_URL}/admin/report/monthlysalestrendreport`, icon: "file", title: "Monthly Sales Trend", type: "link" },
                    { path: `${process.env.PUBLIC_URL}/admin/report/daywisesalestrendreport`, icon: "file", title: "Daywise Sales Trend", type: "link" },

                ],
            },
            { path: `${process.env.PUBLIC_URL}/admin/datagrid`, icon: "table", title: "Data Grid", type: "link" },
        ]
    },

    {
        menutitle: "General Settings",
        menucontent: "Ready to use Apps",
        Items: [
            { path: `${process.env.PUBLIC_URL}/admin/settings`, icon: "internationalization", title: "Settings", type: "link" },
            ...(localStorage.getItem("manageConfigurations") === "1"
                ? [{ path: `${process.env.PUBLIC_URL}/admin/configurations`, icon: "to-do", title: "Configurations", type: "link" }]
                : []),
            { path: `${process.env.PUBLIC_URL}/admin/tenant/viewtenant`, icon: "widget", title: "Tenants", type: "link" },
            ...(localStorage.getItem("accessLicenses") === "1" || localStorage.getItem("manageLicenses") === "1"
                ? [{ path: `${process.env.PUBLIC_URL}/admin/licenses`, icon: "to-do", title: "License Inventory", type: "link" }]
                : []),
        ],
    },

    {
        menutitle: "Admin Settings",
        menucontent: "Ready to use Apps",
        Items: [

            { path: `${process.env.PUBLIC_URL}/admin/usermanagement`, icon: "user", title: "Users & Roles", type: "link" },
            { path: `${process.env.PUBLIC_URL}/admin/logs`, icon: "social", title: "Logs", type: "link" },
            { path: `${process.env.PUBLIC_URL}/admin/schedulereports`, icon: "email", title: "Schedule Reports", type: "link" },
            { path: `${process.env.PUBLIC_URL}/admin/tenantportal`, icon: "button", title: "Tenant Portal", type: "link" },
            ...(localStorage.getItem("accessHealthCheckup") === "1"
                ? [{ path: `${process.env.PUBLIC_URL}/admin/healthcheckup`, icon: "builders", title: "Live Health Checkup", type: "link" }]
                : []),
        ],
    },
    {
        menutitle: "",
        menucontent: "Ready to use Apps",
        Items: [


        ],
    },

];
